// US-072: report column set for the Create-PO-from-supplier table.
//
// PurchaseOrderCreate.fetchData() previously omitted `columns`, letting
// SupplierModel.fetchProductsWithOptions apply its default push-list. Because
// passing `columns` REPLACES that list (see supplier.ts), we replicate the exact
// defaults here and append the reorder-parameter measures so the rows carry
// them. Supplier/base identity/image/product columns are still added by the
// backend + the unconditional supplier push, so the table is unchanged apart
// from the new measures.
//
// Import-free of SupplierModel so it unit-tests without the dateformat issue.

export interface ReportColumnDef { code: string; dataType: string; name: string; }

/** Mirrors the default push-list in supplier.ts fetchProductsWithOptions. */
const DEFAULT_CREATE_REPORT_COLUMNS: ReportColumnDef[] = [
  { code: 'variant_id', dataType: 'number', name: 'Variant ID' },
  { code: '[average_daily_units_sold_param]', dataType: 'number', name: 'Units Sold Per Day' },
  { code: '[sold_quantity_param]', dataType: 'number', name: 'Units Sold' },
  { code: '[stock_days_inventory_planning]', dataType: 'number', name: 'Inventory Remaining Days' },
  { code: '[inventory_replenishment]', dataType: 'number', name: 'Reorder Quantity' },
  { code: '[reorder_date]', dataType: 'number', name: 'Reorder Date' },
  { code: 'product_barcode', dataType: 'string', name: 'Barcode' },
  { code: '[incoming_inventory_quantity]', dataType: 'number', name: 'Incoming Inventory' },
  { code: '[unit_cost]', dataType: 'number', name: 'Unit Cost' },
];

/**
 * Build the Create-PO report column request: the existing default measures plus
 * the reorder-parameter measures the caller actually needs (the report codes of
 * the reorder-param columns currently enabled). Passing only the enabled codes
 * avoids asking the backend to compute all ten measures on every fetch when the
 * merchant has none (or few) enabled. Fresh array each call (the report helper
 * mutates the columns array via .push()).
 */
export function buildCreateReportColumns(reorderReportCodes: string[] = []): ReportColumnDef[] {
  return [
    ...DEFAULT_CREATE_REPORT_COLUMNS.map((c) => ({ ...c })),
    ...reorderReportCodes.map((code) => ({ code, dataType: 'number', name: code })),
  ];
}
